import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TicketInsightComponent } from './insight/ticket/ticket.component';

const routes: Routes = [
  {
    path: 'insight', loadChildren: () => import('./insight/insight.module').then(m => m.InsightModule),
    data: {
      privilege: 'User'
    }
  }
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterModule.forChild(routes)
  ],
  providers: [
    ],
  declarations: [
    ]
})
export class AutotaskModule {
  constructor() {
  }
}
